import TooltipCommon from 'components/common/TooltipCommon';
import TooltipCommonMobile from 'components/common/TooltipCommon/mobile';
import { getNumberUnmaskStr } from 'components/FormEditReceiver/func';
import { DESKTOP_MIN_WIDTH } from 'constants';
import { formatter } from 'helpers';
import { Fade } from 'helpers/animation';
import { checkMaintenance } from 'helpers/maintenance';
import useDebounceCallback from 'hooks/useDebounceCallback';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import { stringUtils } from 'utils';

const customFormInputStyleMobile = {};

const customFormInputStyle = {};

const FormInputEwalletNumberValidation = ({
  field,
  config,
  numberMaskStr,
  setNumberMaskStr,
  accountNumberExisteds,
  information,
  setInformation,
  validation,
  setValidation,
  checkAccountExisted,
  styles = {},
}) => {
  const { t } = useLang();
  const { isMobile, isTablet, isDesktop } = useDetectDevice();

  const isConfigRequired = config?.required;

  const isConfigVisible = config?.visible;

  const placeholder = config?.example;

  const numberFormat = formatter.formatParse(config?.format);

  const numberMaxLength = config?.max;

  const numberMinLength = config?.min;

  const [isChecking, setChecking] = useState(false);

  const prefixFormat = stringUtils.getFirstIntegers(numberFormat[0] || '');

  const checkPrefixFormatMatching = (accountNumber) => {
    const prefixLength = prefixFormat?.length;

    return accountNumber?.slice(0, prefixLength) === prefixFormat;
  };

  useEffect(() => {
    if (information[field.name]) {
      const numberMask = formatter.mask(
        getNumberUnmaskStr(information[field.name], numberFormat),
        numberFormat
      );
      setNumberMaskStr(numberMask);
    }
  }, []);

  useEffect(() => {
    if (!information[field.name]) {
      setNumberMaskStr('');
    }
  }, [information]);

  useEffect(() => {
    const numberUnmaskStr = getNumberUnmaskStr(
      information[field.name],
      numberFormat
    );
    const isCheckNumber =
      numberUnmaskStr?.length <= numberMaxLength &&
      numberUnmaskStr?.length >= numberMinLength &&
      !validation[field.name];

    if (isCheckNumber && isChecking) {
      handleNumberValid(numberUnmaskStr, validation, information);
    }
  }, [isChecking]);

  const handleNumberValidation = async (
    value,
    name,
    validation,

    information
  ) => {
    try {
      return validation;
    } catch (error) {
      checkMaintenance(error);
      console.error(error?.message);

      validation = {
        ...validation,
        [name]: field.msgNumberInvalid,
      };
    }

    return validation;
  };
  const checkNumberValid = async (value, validation, information) => {
    if (!validation[field.name]) {
      validation = await handleNumberValidation(
        value,
        field.name,
        validation,
        information
      );
    }

    setValidation(validation);
  };
  const { debounce: handleNumberValid } = useDebounceCallback(
    (value, validation, information) => {
      checkNumberValid(value, validation, information);
    },
    0
  );

  const { debounce: handleAllowCheckEwalletNumber } = useDebounceCallback(
    (validation) => {
      if (validation[field.name]) {
        setChecking(false);
      } else {
        setChecking(true);
      }
    },
    0
  );

  const handleOnChange = (e) => {
    let { value, name } = e.target;
    let valueTrim = value.trim();

    setChecking(false);

    const numberUnmaskStr = getNumberUnmaskStr(valueTrim, numberFormat);

    if (numberUnmaskStr?.length > numberMaxLength) return;

    if (!numberUnmaskStr) {
      const newInfomation = {
        ...information,
        [name]: '',
      };
      setInformation(newInfomation);

      let newValidation = {
        ...validation,
        [name]: '',
      };

      if (isConfigVisible && !numberUnmaskStr) {
        newValidation = {
          ...newValidation,
          [name]: field.msgRequired,
        };
      }

      setValidation(newValidation);

      setNumberMaskStr('');

      return;
    }

    let newInformation = {
      ...information,
    };

    let newValidation = {
      ...validation,
    };

    const numberStr = formatter.mask(numberUnmaskStr, numberFormat);
    setNumberMaskStr(numberStr);

    newValidation = {
      ...newValidation,
      [name]: '',
    };

    newInformation = {
      ...newInformation,
      [name]: numberUnmaskStr,
    };

    newValidation = checkAccountExisted(
      accountNumberExisteds,
      newInformation,
      newValidation
    );

    if (isConfigVisible && numberUnmaskStr) {
      if (numberUnmaskStr.length < numberMinLength) {
        newValidation = {
          ...newValidation,
          [field.name]: field.msgInvalid,
        };
      }

      if (prefixFormat && !checkPrefixFormatMatching(numberUnmaskStr)) {
        newValidation = {
          ...newValidation,
          [field.name]: 'form_mobile_invalid_5',
        };
      }
    }

    handleAllowCheckEwalletNumber(newValidation);

    setInformation(newInformation);

    setValidation(newValidation);
  };

  const handleFormLabelOnClick = (e, name) => {
    e.preventDefault();

    if (isDesktop) {
      const inputEle = document.getElementsByName(name)[0];

      if (inputEle) {
        inputEle.focus();
      }
    }
  };

  const getMessageValidation = (validation) => {
    const numberUnmaskStr = getNumberUnmaskStr(numberMaskStr, numberFormat);

    if (prefixFormat && !checkPrefixFormatMatching(numberUnmaskStr)) {
      return stringUtils.replaceKeyword(
        t(validation[field.name]),
        [
          {
            key: '0',
            value: prefixFormat,
          },
        ],
        ''
      );
    }

    if (
      numberMinLength &&
      numberUnmaskStr.length < numberMinLength &&
      numberMinLength === numberMaxLength
    ) {
      return stringUtils.replaceKeyword(t(validation[field.name]), [
        {
          key: 'range',
          value: `${numberMaxLength}`,
        },
      ]);
    }

    if (numberMinLength && numberUnmaskStr.length < numberMinLength) {
      return stringUtils.replaceKeyword(t(validation[field.name]), [
        {
          key: 'range',
          value: `${numberMinLength}-${numberMaxLength}`,
        },
      ]);
    }

    if (numberUnmaskStr?.length < numberMinLength) {
      return stringUtils.replaceKeyword(t(validation[field.name]), [
        {
          key: 'range',
          value: numberMaxLength,
        },
      ]);
    }

    return t(validation[field.name]);
  };

  return (
    <FormGroupStyled
      style={
        isMobile || isTablet
          ? { ...customFormInputStyleMobile[field.name], ...styles }
          : { ...customFormInputStyle[field.name], ...styles }
      }
    >
      <FormLabel onClick={(e) => handleFormLabelOnClick(e, field.name)}>
        {config?.label || t(field.label)}
        {(isConfigRequired ?? field.isRequired) && <span>*</span>}
        {config.tooltip && (
          <>
            {isMobile || isTablet ? (
              <TooltipCommonMobile text={config.tooltip} name={field.name} />
            ) : (
              <TooltipCommon text={t(config.tooltip)} />
            )}
          </>
        )}
      </FormLabel>
      <FormControl
        type={field.type}
        name={field.name}
        value={numberMaskStr}
        placeholder={placeholder || t(field.placeholder)}
        onChange={handleOnChange}
        isInvalid={validation[field.name]}
        readOnly={field.isReadOnly}
        inputMode="numeric"
      />
      <FormControlFeedback hidden={false} type="invalid">
        {getMessageValidation(validation).replace('account number', 'number')}
      </FormControlFeedback>
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 32px;
  position: relative;
  ${Fade};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 34px;
  }
`;
const FormLabel = styled(Form.Label)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: left;

  display: block;
  color: var(--ds-c-grey-dark);

  span {
    color: var(--c-required);
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;
const FormControl = styled(Form.Control)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;

  color: ${(props) =>
    props.istextcolordisabled
      ? 'var(--ds-c-grey-neutral)'
      : 'var(--ds-c-grey-dark)'};
  height: 44px;
  border: 1px solid var(--ds-c-grey-light);
  border-radius: 12px;
  padding-inline: 10px;
  background: ${(props) =>
    props.istextcolordisabled
      ? 'var(--ds-c-grey-disabled)'
      : 'var(--ds-c-white)'};
  cursor: ${(props) => props.istextcolordisabled && 'not-allowed'};

  &:focus {
    background: ${(props) =>
      props.istextcolordisabled && 'var(--ds-c-grey-disabled)!important'};
    border: 1px solid var(--ds-c-grey-dark) !important;
    outline: none !important;
    box-shadow: none !important;
  }

  &:invalid,
  &:invalid:focus,
  &.is-invalid {
    border: 1px solid var(--ds-c-red) !important;
    outline: none !important;
    box-shadow: none !important;
    background-image: none !important;
    padding-inline: 10px !important;
  }

  &[readonly] {
    background: ${(props) =>
      props.istextcolordisabled && 'var(--ds-c-grey-disabled)!important'};
    border: none !important;
  }

  &::placeholder {
    font-family: var(--ff-primary);
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    text-transform: none;

    color: var(--ds-c-blue-disabled) !important;

    @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
      font-size: 16px;
      line-height: 20px;
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;
const FormControlFeedback = styled(Form.Control.Feedback)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;

  color: var(--ds-c-red);
  position: absolute;
  margin-top: 4px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 14px;
    line-height: 17px;
  }
`;

export default FormInputEwalletNumberValidation;
